

import React, { useState } from 'react';

interface ExportModalProps {
    isOpen: boolean;
    onClose: () => void;
    onExport: (options: { format: 'Excel' | 'PDF', dateRange: { start: string, end: string }, type: 'all' | 'income' | 'expense' }) => void;
    format: 'Excel' | 'PDF';
}

const ExportModal: React.FC<ExportModalProps> = ({ isOpen, onClose, onExport, format }) => {
    const [type, setType] = useState<'all' | 'income' | 'expense'>('all');
    
    const today = new Date().toISOString().split('T')[0];
    const [startDate, setStartDate] = useState(today);
    const [endDate, setEndDate] = useState(today);

    const handleSetDateRange = (preset: 'today' | 'this_month' | 'last_30' | 'this_year') => {
        const now = new Date();
        let start = new Date();
        const end = new Date();

        switch (preset) {
            case 'today':
                start = new Date(now.getFullYear(), now.getMonth(), now.getDate());
                break;
            case 'this_month':
                start = new Date(now.getFullYear(), now.getMonth(), 1);
                break;
            case 'last_30':
                start.setDate(now.getDate() - 30);
                break;
            case 'this_year':
                start = new Date(now.getFullYear(), 0, 1);
                break;
        }
        setStartDate(start.toISOString().split('T')[0]);
        setEndDate(end.toISOString().split('T')[0]);
    };

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if (!startDate || !endDate) {
            alert("Por favor, selecciona un rango de fechas válido.");
            return;
        }
        onExport({
            format,
            dateRange: { start: startDate, end: endDate },
            type,
        });
        onClose();
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-70 z-50 flex justify-center items-center" onClick={onClose}>
            <div className="bg-light-surface dark:bg-surface rounded-lg shadow-xl p-8 w-[95%] sm:w-full max-w-lg border border-light-border dark:border-border" onClick={e => e.stopPropagation()}>
                <h2 className="text-2xl font-bold text-light-text-primary dark:text-text-primary mb-6">Opciones de Exportación ({format})</h2>
                <form onSubmit={handleSubmit} className="space-y-6">
                    <div>
                        <label className="block text-sm font-medium text-light-text-secondary dark:text-text-secondary mb-2">Tipo de movimiento</label>
                        <div className="flex gap-2 rounded-lg bg-gray-200 dark:bg-gray-800 p-1">
                            {(['all', 'income', 'expense'] as const).map(option => (
                                <button key={option} type="button" onClick={() => setType(option)} className={`flex-1 py-2 text-sm font-medium rounded-md transition-colors ${type === option ? 'bg-primary text-white shadow' : 'text-light-text-secondary dark:text-text-secondary hover:bg-gray-300 dark:hover:bg-gray-700'}`}>
                                    {option === 'all' ? 'Todos' : option === 'income' ? 'Ingresos' : 'Gastos'}
                                </button>
                            ))}
                        </div>
                    </div>
                    
                    <div>
                        <label className="block text-sm font-medium text-light-text-secondary dark:text-text-secondary mb-2">Rango de fechas</label>
                        <div className="flex flex-col sm:flex-row gap-4">
                            <input type="date" value={startDate} onChange={e => setStartDate(e.target.value)} required className="w-full bg-light-background dark:bg-background border border-light-border dark:border-border rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary" />
                            <input type="date" value={endDate} onChange={e => setEndDate(e.target.value)} required className="w-full bg-light-background dark:bg-background border border-light-border dark:border-border rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary" />
                        </div>
                         <div className="flex flex-wrap gap-2 mt-3">
                            <button type="button" onClick={() => handleSetDateRange('today')} className="px-3 py-1 text-xs bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600 rounded-full">Hoy</button>
                            <button type="button" onClick={() => handleSetDateRange('this_month')} className="px-3 py-1 text-xs bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600 rounded-full">Este mes</button>
                            <button type="button" onClick={() => handleSetDateRange('last_30')} className="px-3 py-1 text-xs bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600 rounded-full">Últimos 30 días</button>
                            <button type="button" onClick={() => handleSetDateRange('this_year')} className="px-3 py-1 text-xs bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600 rounded-full">Este año</button>
                        </div>
                    </div>

                    <div className="flex justify-end gap-4 pt-4">
                        <button type="button" onClick={onClose} className="px-4 py-2 rounded-md bg-gray-200 dark:bg-gray-600 hover:bg-gray-300 dark:hover:bg-gray-500 text-light-text-primary dark:text-text-primary transition-colors">Cancelar</button>
                        <button type="submit" className="px-6 py-2 rounded-md bg-secondary hover:bg-green-600 text-white font-semibold transition-colors">
                            Exportar
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ExportModal;
